import { render, staticRenderFns } from "./orderOn.vue?vue&type=template&id=3018dfbe&scoped=true&"
import script from "./orderOn.vue?vue&type=script&lang=js&"
export * from "./orderOn.vue?vue&type=script&lang=js&"
import style0 from "./orderOn.vue?vue&type=style&index=0&id=3018dfbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3018dfbe",
  null
  
)

export default component.exports